import * as mobileActions from '../actions/screen.actions';
import * as ScreenState from '../states/screen.state';

export class State extends ScreenState.State { }

const initialState: ScreenState.State = ScreenState.initialState;

export const MOBILE_MAX_WIDTH = 600;
export const TABLET_MAX_WIDTH = 900;
export const TABLET_LANDSCAPE_WIDTH = 1200;

export function reducer(state: State = initialState,
	action: mobileActions.Actions): ScreenState.State {
	switch (action.type) {
		case mobileActions.ActionTypes.SET_SCREEN:
			state = Object.assign({}, state,
				{
					mobile: action.payload <= MOBILE_MAX_WIDTH,
					mobileTabletPortrait: action.payload < TABLET_MAX_WIDTH,
					tabletPortrait: action.payload < TABLET_MAX_WIDTH && action.payload > MOBILE_MAX_WIDTH,
					tabletLandscape: action.payload < TABLET_LANDSCAPE_WIDTH && action.payload > TABLET_MAX_WIDTH,
					desktop: action.payload > TABLET_LANDSCAPE_WIDTH
				});
			return state;
		default:
			return state;
	}
}

export const getMobile = (state: ScreenState.State) => state.mobile;
export const getMobileTabletPortrait = (state: ScreenState.State) => state.mobileTabletPortrait;
export const getTabletPortrait = (state: ScreenState.State) => state.tabletPortrait;
export const getTabletLandscape = (state: ScreenState.State) => state.tabletLandscape;
export const getDesktop = (state: ScreenState.State) => state.desktop;


